import columns from "../../../../../react-table/helpers/columns";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";
import { showTotalProp } from "../../../../../react-table/helpers/rowTotals";

export const getCarrierTabNavigationProps =
  (originExchangeOfficesData) => (rowInfo) =>
    rowInfo && rowInfo.row
      ? {
          reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
          mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id,
          requestParams: {
            carrierCode: rowInfo.row["carrier"], // eslint-disable-line
            originExchangeOffices:
              originExchangeOfficesData.originExchangeOffices,
          },
          selectionCriteriaOptions: {
            includeSelectionCriteria: true,
          },
          reportsToBeCleared: [
            ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_DETAILS.id,
          ],
        }
      : {};

const splitData = (data) => {
  return data.reduce(
    (acc, row) => {
      if (row.carrier && row.carrier.toLowerCase() === "total") {
        acc.totalRow = row;
      } else {
        acc.dataRows.push(row);
      }
      return acc;
    },
    {
      totalRow: undefined,
      dataRows: [],
    }
  );
};

export default (data, originExchangeOfficesData) => {
  const { totalRow, dataRows } = splitData(data);

  const { TextColumn, NavigationWithFooterColumn, NonZeroNumberColumn } =
    columns(data);

  return [
    {
      Header: "",
      columns: [
        new TextColumn("Carrier", "carrier").withTotalHeader(
          "Total",
          "bg-total-grey"
        ),
      ],
    },
    {
      Header: "Receptacles",
      columns: [
        new NavigationWithFooterColumn(
          new NonZeroNumberColumn("Total", "receptacles.total").withTotalHeader(
            showTotalProp(totalRow, "receptacles.total"),
            "bg-total-grey"
          ),
          getCarrierTabNavigationProps(originExchangeOfficesData)
        ),
        new NonZeroNumberColumn(
          "LHOT origin",
          "receptacles.lhotOrigin"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.lhotOrigin"),
          "bg-total-grey"
        ),
        new NonZeroNumberColumn(
          "LHOT destination",
          "receptacles.lhotDestination"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.lhotDestination"),
          "bg-total-grey"
        ),
        new NonZeroNumberColumn(
          "Contract reference",
          "receptacles.contractReference"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.contractReference"),
          "bg-total-grey"
        ),
        new NonZeroNumberColumn(
          "Booking reference",
          "receptacles.bookingReference"
        ).withTotalHeader(
          showTotalProp(totalRow, "receptacles.bookingReference"),
          "bg-total-grey"
        ),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
        mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id,
        requestParams: {
          isTotal: true,
          carrierCode: "*",
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
